import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { ROUTES } from '../../helpers/menus/routeConstants';
import { useMediaQuery } from 'react-responsive';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import './PrimaryNav.css';

const PrimaryNav = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const mediumScreens = useMediaQuery({ maxWidth: 720});
  const primaryNavTabClasses = 'padding-1 height-full display-inline-block text-base-lightest text-no-underline font-sans-3xs desktop:font-sans-lg fs-1rem'
  const hamburgerMenu = 
    <svg 
      className={`text-primary usa-icon usa-icon--size-4 white`}
      xmlns="http://www.w3.org/2000/svg" 
      width="1em" 
      height="1em" 
      viewBox="0 0 24 24"  
      focusable="false"
      role="img">
      <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"></path>
    </svg>
  
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const determineStatusForHelpSupport = () => {
    if (!window.location.pathname.includes('become-provider') && window.location.pathname.includes('help')) {
      return `${primaryNavTabClasses} border-bottom border-white`;
    } else {
      return primaryNavTabClasses;
    }
  }


  return (
    <nav className='primary-nav h-rem-4 flex ai-c sb'>
      <div className='flex sm-gap'>
        <a href='/' className='flex ai-c'>
          <img src="/cdc-logo.svg" alt="CDC logo" className='cdc-img'/>
        </a>
        <a href='/'>
          <p className='fs-20 white'>
           DEVELOPER  DIGITAL GATEWAY
          </p>
        </a>
      </div>
      <div>

        {
          mediumScreens &&
            <div id="mobile-menu-items">
              <Button
                id="hamburger-menu-items-button"
                data-testid="hamburger-menu-items-button"
                aria-label="Open the menu"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
              >
                {hamburgerMenu}
              </Button>
              <Menu
                id="menu-items-display"
                data-testid="menu-items-display"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  'aria-labelledby': 'basic-button',
                }}
              >
                <MenuItem>
                  <NavLink to={ROUTES["API Library"]} className='menu-item'>
                      Explore APIs
                  </NavLink>
                </MenuItem>
                <MenuItem>                  
                  <NavLink to={ROUTES["Become an API Provider"]} className='menu-item'>
                      Become an API Producer
                  </NavLink>
                </MenuItem>
                {/* <MenuItem>
                  <NavLink 
                    to={ROUTES["API Status"]} 
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="API Status page opens in a new tab"
                    className='menu-item'
                    >
                      API Status
                  </NavLink>
                </MenuItem> */}
                <MenuItem>                  
                  <NavLink to={ROUTES["About Us"]} className='menu-item'>
                      About
                  </NavLink>
                </MenuItem>
                <MenuItem>                  
                  <NavLink to={ROUTES["Help & Support"]} className='menu-item'>
                      Support
                  </NavLink>
                </MenuItem>
              </Menu>
            </div>
        }

        { !mediumScreens && 
          <div id="nav-items" className='flex'>
              <div key="apiLibrary">
                <NavLink 
                  to={ROUTES["API Library"]} 
                  className={props =>
                    props.isActive ? `${primaryNavTabClasses} border-bottom border-white` : primaryNavTabClasses
                  }
                  >
                    Explore APIs
                </NavLink>
              </div>

              <div key="provider" className="margin-left-1">
                <NavLink 
                  to={ROUTES["Become an API Provider"]} 
                  className={props =>
                    props.isActive ? `${primaryNavTabClasses} border-bottom border-white` : primaryNavTabClasses
                  }
                  >
                    Become an API Producer
                </NavLink>
              </div>

              {/* <div key="status" className="margin-left-1">
                <NavLink 
                  to={ROUTES["API Status"]} 
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="API Status page opens in a new tab"
                  className={props =>
                    props.isActive ? `${primaryNavTabClasses} border-top border-white` : primaryNavTabClasses
                  }
                  >
                    API Status
                </NavLink>
              </div> */}

              <div key="about" className="margin-left-1">
                <NavLink 
                  to={ROUTES["About Us"]} 
                  className={props =>
                    props.isActive ? `${primaryNavTabClasses} border-bottom border-white` : primaryNavTabClasses
                  }
                  >
                    About
                </NavLink>
              </div>

              <div key="help&support" className="margin-left-1">
                <NavLink 
                  to={ROUTES["Help & Support"]}
                  className={determineStatusForHelpSupport()}
                  >
                    Support
                </NavLink>
              </div>
          </div>
        }
      </div>
    </nav>
  )
};

export default PrimaryNav;
